import { useState, useCallback } from 'react';
import type React from 'react';

interface ConfirmState {
  open: boolean;
  title?: string;
  message: React.ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  variant?: 'danger' | 'warning' | 'info';
  /** High-stakes treatment (paprika ticker + "This can't be undone"). */
  highStakes?: boolean;
  onConfirm: () => void;
}

export function useConfirmDialog() {
  const [state, setState] = useState<ConfirmState>({
    open: false, message: '', onConfirm: () => {},
  });

  const showConfirm = useCallback((opts: Omit<ConfirmState, 'open'>) => {
    setState({ ...opts, open: true });
  }, []);

  const handleConfirm = useCallback(() => {
    state.onConfirm();
    setState(s => ({ ...s, open: false }));
  }, [state]);

  const handleCancel = useCallback(() => {
    setState(s => ({ ...s, open: false }));
  }, []);

  return { dialogProps: { ...state, onConfirm: handleConfirm, onCancel: handleCancel }, showConfirm };
}
